import { Injectable, ViewContainerRef } from '@angular/core';

@Injectable()
export class LMFieldManualRepService {

  private _manualRepFields = {};

  constructor() {}

  public setManualRepFields(repName, manualRepFields) {
    this._manualRepFields[repName] = manualRepFields
  }

  public getManualRefFields() {
    return this._manualRepFields;
  }
}
